export const HomePageStyles = {
    container: "px-4 sm:px-6 md:px-10 lg:px-20 max-w-screen-xl my-12 ml-2 sm:ml-0",
    welcomeText: "text-[36px] leading-[44px] tracking-[-0.02em] font-bold text-[#04051D] text-center mb-10"
}